<template>
  <b-modal
    v-model="isVisible"
    hide-header
    hide-footer
    modal-class="price-table-modal-top"
    backdrop-class="price-table-modal-backdrop-top"
    @hide="hidePriceTableModal"
  >
    <PriceTable
      :show-price-table="true"
      :external-page="true"
      :point-id="pointId"
      :token="token"
      @close="hidePriceTableModal"
    />
  </b-modal>
</template>

<script>
  import '@/main.scss'

  import { sessionRecorder, UserEvent } from '@/services/sessionRecorder'
  import PriceTable from '@/components/PriceTable.vue'

  const GTAG_PRICE_TABLE = 'open_price_table'

  export default {
    name: 'PriceTableModal',
    components: {
      PriceTable
    },
    props: {
      pointId: {
        type: [Number, String],
        default: null
      },
      token: {
        type: String,
        default: null
      }
    },
    emits: ['hidePriceTableModal'],
    data() {
      return {
        isVisible: false
      }
    },
    async mounted() {
      this.isVisible = true
      this.logEvent()
    },
    methods: {
      logEvent() {
        const token = localStorage.getItem('token')
        const isLoggedIn = !!token && token !== 'undefined' && token !== 'null'
        const params = {
          link_source: isLoggedIn ? 'logged' : 'not_logged',
          terminal_token: this.token || ''
        }
        sessionRecorder.addUserEvent(new UserEvent(GTAG_PRICE_TABLE, null, params))
      },

      hidePriceTableModal() {
        this.isVisible = false
        this.$emit('hidePriceTableModal')
      }
    }
  }
</script>

<style lang="scss">
  .price-table-modal-top {
    z-index: 13001 !important;

    .modal-dialog {
      max-width: 520px;
    }

    .modal-body {
      padding: 0;
    }
  }
  .price-table-modal-backdrop-top {
    z-index: 13000 !important;
  }
</style>

<style scoped lang="scss">
  @use '@/main';

  .stay-same-line {
    overflow: hidden;
    white-space: nowrap;
  }

  .amount-description-color {
    color: main.$color-energy-orange;
    display: inline-block;
  }

  .footnote {
    font-size: var(--fs-xs);
    margin-top: 13px;
  }
</style>
